'use client';
import { Text } from '@mnd-frontend/ui/publish/components';
import {
  DANGER_200,
  DANGER_800,
  SPACING_0_5,
  SPACING_1,
  SUCCESS_200,
  SUCCESS_800,
} from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import { ReactComponent as ArrowUp } from '../../assets/arrow.svg?react';

type DeltaDirection = 'positive' | 'negative';
const ArrowDown = styled(ArrowUp)`
  transform: rotate(180deg);
`;

const trendBackgroundColors = { positive: SUCCESS_200, negative: DANGER_200 };
const trendTextColors = { positive: SUCCESS_800, negative: DANGER_800 };
const getTrendBackgroundColor = ({ $deltaDirection }: { $deltaDirection: DeltaDirection }) => {
  return trendBackgroundColors[$deltaDirection];
};
const getTrendTextColor = ({ $deltaDirection }: { $deltaDirection: DeltaDirection }) => {
  return trendTextColors[$deltaDirection];
};
const Container = styled.span<{ $deltaDirection: DeltaDirection }>`
  background-color: ${getTrendBackgroundColor};
  color: ${getTrendTextColor};
  border-radius: 0.5rem;
  padding: 0.125rem ${SPACING_0_5} 0.125rem ${SPACING_1};
  display: inline-flex;
  align-items: center;
  flex-align: flex-start;
`;

export const TrendPill = ({
  direction,
  value,
}: {
  direction: 'positive' | 'negative';
  value: string;
}) => {
  return (
    <Container $deltaDirection={direction}>
      <Text as="span" variant="reportLabelMedium" mobileVariant="reportLabelSmall">
        {value}
      </Text>
      {direction === 'positive' ? <ArrowUp /> : direction === 'negative' ? <ArrowDown /> : null}
    </Container>
  );
};
